import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Array of step descriptors. Each entry needs a `title` (visible label) and a `value` (stable identity used by the completed-map and for keying). Pass via `.prop` binding because arrays cannot be expressed as attribute strings.
   *
   * @type {Array}
   * @default []
   * @storybook-control object
   */
  items: {
    type: Array,
    default: () => [],
  },
  /**
   * Key on each item used as the visible step label.
   *
   * @type {String}
   * @default "title"
   */
  itemTitle: {
    type: String,
    default: "title",
  },
  /**
   * Key on each item used for identity comparison against the `completed` hash.
   *
   * @type {String}
   * @default "value"
   */
  itemValue: {
    type: String,
    default: "value",
  },
  /**
   * Key on each item that holds a nested props bag — used as a fallback source for per-item flags like `completed`.
   *
   * @type {String}
   * @default "props"
   */
  itemProps: {
    type: String,
    default: "props",
  },
  /**
   * Hash keyed by item `value` whose truthy entries mark steps as completed (rendered with a check icon and a filled divider on either side). Pass via `.prop`.
   *
   * @type {Object}
   * @default {}
   * @storybook-control object
   */
  completed: {
    type: Object,
    default: () => ({}),
  },
  /**
   * Zero-based index of the active step. Two-way: emits `update-selected` whenever the active step changes.
   *
   * @type {Number}
   * @default 0
   * @storybook-control number
   */
  selected: {
    type: Number,
    default: 0,
  },
  /**
   * Hide the built-in Previous/Next footer. Drive the active step from host code via `selected` instead.
   *
   * @type {Boolean|String}
   * @default false
   */
  noActions: booleanAttribute(),
  /**
   * Make the window area fill the host height and clip overflow. Use inside a fixed-height shell (a modal, a card) where the step content should scroll independently.
   *
   * @type {Boolean|String}
   * @default false
   */
  scrollable: booleanAttribute(),
});
